import { Component, OnInit, HostBinding } from '@angular/core';
import { ElementService, ElementDataBill } from '../service/element.service';
import { FillAt } from '../service/bill-param';
import { VisibilityType } from 'dbweb-core';
import ace from 'ace-builds';
import { ThemeService } from '../../services/theme.service';
@Component({
	selector: 'common-set-property-bill',
	templateUrl: './set-property-bill.component.html',
	styleUrls: ['./set-property-bill.component.scss']
})
export class SetPropertyBillComponent implements OnInit {
	@HostBinding('class.set-property-bill') hostClass = true;
	edtOption: any = { maxLines: 12, printMargin: false };
	public svr = this.elementSvr.data.bill as ElementDataBill;
	isReadonly = this.svr.parent.bill.isDelete() || this.svr.parent.bill.isBrowse();
	readonly SkipFill = FillAt.SkipFill;
	readonly FillAtOpen = FillAt.FillAtOpen;
	readonly FillAtSave = FillAt.FillAtSave;
	options = [
		{
			Name: 'ç¨æ·å',
			Value: '{{.User.Name}}'
		},
		{
			Name: 'é¨é¨ä»£ç ',
			Value: '{{.User.Dept.Code}}'
		},
		{
			Name: 'é¨é¨åç§°',
			Value: '{{.User.Dept.Name}}'
		},
		{
			Name: 'å½åæ¶é´',
			Value: '{{datetime}}'
		},
		{
			Name: 'å½åæ¥æ',
			Value: '{{date}}'
		},
		{
			Name: 'å¯ä¸ç¼å·',
			Value: '{{guid64}}'
		}
	];
	primaryKeyFillOptions = [
		...this.options,
		{
			Name: 'åå¼',
			Value: '{{.SRC}}'
		}
	];
	constructor(public elementSvr: ElementService, public theme: ThemeService) {}

	ngOnInit() {
		ace.config.set('basePath', '/front/assets/ace-builds/src-min-noconflict');
	}

	// å¯æä½/åªè¯»/ä¸å¯è§
	selectShow(e: VisibilityType) {
		this.svr.Param.FieldSettings.forEach(v => {
			v.Visibility = e;
		});
	}

	// ä¸å¡«å/æå¼æ¶/ä¿å­æ¶
	selectSave(e: FillAt) {
		this.svr.Param.FieldSettings.forEach(v => {
			v.FillAt = e;
		});
	}
	// å¯æä½/åªè¯»/ä¸å¯è§
	selectCloneShow(e: VisibilityType) {
		this.svr.Param.ClonePrimaryKeySettings.forEach(v => {
			v.Visibility = e;
		});
	}
}
